import { useEffect } from 'react'
import ReactGA from 'react-ga'
import { IQuestion } from 'models'

// Button Interaction Tracking
export const trackButtonInteraction = (button: string, action: string) => {
  ReactGA.event({
    action: `OOF Button ${action}`,
    category: 'OOF V2', // category to differ different interactions
    label: `OOF ${button}`,
  })
}

const pathname = window ? window.location.pathname : '/orgasm-order-form'

// Screen Tracking
// path is virtual, the app has no route currently
export const useScreenTrack = (path: string) => {
  useEffect(() => {
    ReactGA.ga('set', 'page', `${pathname}/${path}`)
    ReactGA.ga('send', 'pageview')
  }, [path])
}

// Question Tracking
// Virtually change the path for each question change, this way we can tell from GA the exit pages
export const useQuestionTrack = (currentQuestion: IQuestion) => {
  useEffect(() => {
    if (currentQuestion) {
      ReactGA.ga('set', 'page', `${pathname}/question/${currentQuestion.order}`)
      ReactGA.ga('send', 'pageview')
    }
  }, [currentQuestion])
}

// Subscription Box Tracking
export const trackSubscription = () => {
  ReactGA.event({
    action: 'OOF Subscribe to Newsletter',
    category: 'OOF V2', // category to differ different interactions
    label: `OOF Subscription Box`,
  })
}

// Product Tracking
export const trackingProductView = (productTitle: string) => {
  ReactGA.event({
    action: 'View',
    category: 'OOF V2',
    label: `OOF Product Tile - ${productTitle}`,
  })
}
export const trackingProductClick = (productTitle: string) => {
  ReactGA.event({
    action: 'Click',
    category: 'OOF V2',
    label: `OOF Product Tile - ${productTitle}`,
  })
}

// Not too sure what/where the fbq is set on the window, it's undefined in local development so
// just extending the window type for now.
interface CustomWindow extends Window {
  fbq: (name: string, event: string) => void
}
declare let window: CustomWindow
// Facebook pixel events tracking, the fb pixel need to be present in the page
export const trackFBCustomEvent = (event: string) => {
  if (typeof window !== 'undefined' && window.fbq !== undefined) {
    window.fbq('trackCustom', event)
  }
}
